// extracted by mini-css-extract-plugin
export default {"defaultToggle":"IRzdIAYE2imlNqmsnKZg","defaultToggleLabel":"UKC9KwpNIwtcCvLy9G1I"};